import { isRecord } from './isRecord'

export type ErrorLike = {
  type: string
  message: string
  stack: string
}

export const isErrorLike = (value: unknown): value is ErrorLike => {
  return (
    isRecord(value) &&
    typeof value.type === 'string' &&
    typeof value.message === 'string' &&
    typeof value.stack === 'string'
  )
}
